import { DividerBlockComponent } from './divider-block';

export function effects() {
  customElements.define('hive-divider', DividerBlockComponent);
}
